import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import {
  types as actions,
  setLocationsGeoJsonAction
} from '../../reducers/actions';
import { LocationService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function (action$, store) {
  return action$.pipe(
    ofType(actions.GET_LOCATIONS_GEO_JSON),
    switchMap(action =>
      LocationService.getGeoJsonByAreaId(action.areaId, store).pipe(
        map(data => setLocationsGeoJsonAction(data.response)),
        catchError(retryAuthentication(action$, 'epics/locations/getLocationsGeoJson'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/locations/getLocationsGeoJson.js